import React from "react";
import { useSelector } from "react-redux";
import { Chip, Tooltip } from "@mui/material";
import HealingIcon from "@mui/icons-material/Healing";

/**
 * "Remediate now" indicator for CSPM check rows.
 * Request Fix is only available from the resource drawer (failed resources).
 */
const RequestFixButton = ({ checkId, showPill = true, failedCount = 0, onClick }) => {
  const remediable = useSelector((s) => s.remediation?.remediableChecks);
  const isRemediable = Array.isArray(remediable?.ids) && remediable.ids.includes(checkId);
  const hasFailedResources = Number(failedCount) > 0;

  if (!isRemediable || !showPill || !hasFailedResources) return null;

  const handleClick = (e) => {
    e.stopPropagation();
    onClick?.(e);
  };

  return (
    <Tooltip
      title="Open failed resources to file a task."
      arrow
      placement="top"
    >
      <Chip
        size="small"
        icon={<HealingIcon fontSize="small" />}
        label="Remediate now"
        onClick={onClick ? handleClick : undefined}
        sx={{
          backgroundColor: "#e8f5e9",
          color: "#2e7d32",
          fontWeight: 600,
          fontSize: 11,
          height: 22,
          cursor: onClick ? "pointer" : "default",
          "& .MuiChip-icon": { color: "#2e7d32" },
          ...(onClick && {
            "&:hover": { backgroundColor: "#c8e6c9" },
          }),
        }}
      />
    </Tooltip>
  );
};

export default RequestFixButton;
